/**
 * http://gaode.com)
 */
var heatmapData = [{
  "lng": 116.191031,
  "lat": 39.988585,
  "count": 100
}, {
  "lng": 116.389275,
  "lat": 39.925818,
  "count": 150
}, {
  "lng": 116.287444,
  "lat": 39.810742,
  "count": 120
}, {
  "lng": 116.481707,
  "lat": 39.940089,
  "count": 130
}, {
  "lng": 116.410588,
  "lat": 39.880172,
  "count": 14
}, {
  "lng": 116.394816,
  "lat": 39.91181,
  "count": 100
}, {
  "lng": 116.416002,
  "lat": 39.952917,
  "count": 800
}, {
  "lng": 116.39671,
  "lat": 39.924903,
  "count": 652
}, {
  "lng": 116.180816,
  "lat": 39.957553,
  "count": 75
}, {
  "lng": 116.382035,
  "lat": 39.874114,
  "count": 254
}, {
  "lng": 116.316648,
  "lat": 39.914529,
  "count": 521
}, {
  "lng": 116.395803,
  "lat": 39.908556,
  "count": 32
}, {
  "lng": 116.74553,
  "lat": 39.875916,
  "count": 220
}, {
  "lng": 116.352289,
  "lat": 39.916475,
  "count": 230
}, {
  "lng": 116.441548,
  "lat": 39.878262,
  "count": 410
}, {
  "lng": 116.318947,
  "lat": 39.942735,
  "count": 124
}, {
  "lng": 116.382585,
  "lat": 39.941949,
  "count": 534
}, {
  "lng": 116.42042,
  "lat": 39.884017,
  "count": 270
}, {
  "lng": 116.31744,
  "lat": 39.892561,
  "count": 101
}, {
  "lng": 116.407059,
  "lat": 39.912438,
  "count": 29
}, {
  "lng": 116.412351,
  "lat": 39.888082,
  "count": 300
}, {
  "lng": 116.444341,
  "lat": 39.915891,
  "count": 310
}, {
  "lng": 116.335385,
  "lat": 39.741756,
  "count": 320
}, {
  "lng": 116.3926,
  "lat": 40.008733,
  "count": 33
}, {
  "lng": 116.389731,
  "lat": 39.92292,
  "count": 34
}, {
  "lng": 116.413371,
  "lat": 39.874483,
  "count": 35
}, {
  "lng": 116.199752,
  "lat": 39.911717,
  "count": 36
}, {
  "lng": 116.278472,
  "lat": 40.254994,
  "count": 37
}, {
  "lng": 116.464252,
  "lat": 39.925828,
  "count": 380
}, {
  "lng": 116.479475,
  "lat": 39.937945,
  "count": 39
}, {
  "lng": 116.415599,
  "lat": 39.956902,
  "count": 400
}, {
  "lng": 116.355675,
  "lat": 39.870089,
  "count": 41
}, {
  "lng": 116.295267,
  "lat": 39.987171,
  "count": 420
}, {
  "lng": 116.323634,
  "lat": 39.911692,
  "count": 43
}, {
  "lng": 116.692769,
  "lat": 40.173307,
  "count": 440
}, {
  "lng": 116.287888,
  "lat": 39.928531,
  "count": 45
}, {
  "lng": 116.386502,
  "lat": 39.922747,
  "count": 752
}];
export { heatmapData };